module.exports = __webpack_public_path__ + "media/newstyle/images/icon-pocket-b4c0380acd3f40b03f45d1f92a2caa19.svg";